// src/routes/index.js
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import GroupIcon from "@mui/icons-material/Group";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LogoutIcon from "@mui/icons-material/Logout";
import HomeIcon from "@mui/icons-material/Home";
import HistoryIcon from "@mui/icons-material/History";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
// 👇 Cuenta corriente clientes
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
// 👇 Compras
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// 👇 Proveedores
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// 👇 Productos vendidos
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
// 👇 Sucursales
import StorefrontIcon from "@mui/icons-material/Storefront";
// 👇 Mantenimiento
import BuildIcon from "@mui/icons-material/Build";
// 👇 Grupos de costos (CP4-COSTOS)
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
// 👇 Pagos a Proveedores
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
// 👇 Accesorios
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";

// CP5.4: `perms` = los mismos permisos que exige <RequirePerms> en App.js para
// esa ruta. El Sidenav oculta lo que el usuario no puede abrir (antes se
// mostraba todo y la ruta lo devolvía al Dashboard). La seguridad real está en
// el backend; esto es solo la navegación.
const routes = [
  { type: "title", title: "DASHBOARD", key: "title-dashboard" },
  {
    type: "collapse",
    name: "Inicio",
    key: "dashboard",
    route: "/dashboard",
    icon: <HomeIcon />,
  },

  { type: "title", title: "PRODUCTOS", key: "title-productos" },
  {
    type: "collapse",
    name: "Ingreso manual",
    key: "alta-productos",
    route: "/alta-productos",
    perms: ["productos:create"],
    icon: <LibraryAddIcon />,
  },
  // ❌ Eliminado "Cargar Productos Test"
  {
    type: "collapse",
    name: "Inventario",
    key: "inventario",
    route: "/inventario",
    perms: ["inventario:read"],
    icon: <Inventory2Icon />,
  },
  {
    // Generalización UX (fase "Accesorios" -> "Productos"): sólo cambia el
    // texto visible en el sidebar -- key/route intactos a propósito (no
    // renombrar rutas/endpoints todavía, punto 4 del pedido).
    type: "collapse",
    name: "Productos",
    key: "accesorios",
    route: "/accesorios",
    perms: ["inventario:read"],
    icon: <ExtensionOutlinedIcon />,
  },
  {
    type: "collapse",
    name: "Mantenimiento",
    key: "mantenimiento",
    route: "/mantenimiento",
    perms: ["inventario:read"],
    icon: <BuildIcon />,
  },
  {
    type: "collapse",
    name: "Grupos de costos",
    key: "grupos-costo",
    route: "/grupos-costo",
    perms: ["costos:read", "reportes:read"],
    permsAlguno: true, // CP4.4: alcanza con uno (igual que el backend)
    icon: <AccountTreeOutlinedIcon />,
  },

  { type: "title", title: "VENTAS", key: "title-ventas" },
  {
    type: "collapse",
    name: "Cargar Venta",
    key: "ventas",
    route: "/cargar-venta",
    perms: ["ventas:create"],
    icon: <GroupIcon />,
  },
  {
    type: "collapse",
    name: "Cta. corriente clientes",
    key: "cuenta-corriente-clientes",
    route: "/clientes/cuenta-corriente",
    perms: ["ventas:read"],
    icon: <AccountBalanceWalletOutlinedIcon />,
  },
  {
    type: "collapse",
    name: "Garantías",
    key: "garantias",
    route: "/garantias",
    perms: ["garantias:read"],
    icon: <ShieldOutlinedIcon />,
  },
  {
    type: "collapse",
    name: "Historial Ventas",
    key: "ventas-realizadas",
    route: "/ventas-realizadas",
    perms: ["ventas:read"],
    icon: <ReceiptLongIcon />,
  },
  {
    type: "collapse",
    name: "Productos Vendidos",
    key: "productos-vendidos",
    route: "/productos-vendidos",
    perms: ["ventas:read"],
    icon: <SellOutlinedIcon />,
  },

  // 👇 COMPRAS (solo listado)
  { type: "title", title: "COMPRAS", key: "title-compras" },
  {
    type: "collapse",
    name: "Compras",
    key: "compras",
    route: "/compras",
    perms: ["compras:read"],
    icon: <ShoppingCartIcon />,
  },
  {
    type: "collapse",
    name: "Proveedores",
    key: "proveedores",
    route: "/proveedores",
    perms: ["proveedores:read"],
    icon: <LocalShippingIcon />,
  },
  {
    type: "collapse",
    name: "Cta. corriente proveedores",
    key: "cuenta-corriente-proveedores",
    route: "/proveedores/cuenta-corriente",
    perms: ["proveedores:read"],
    icon: <AccountBalanceWalletOutlinedIcon />,
  },
  {
    type: "collapse",
    name: "Pagos a Proveedores",
    key: "pagos-proveedores",
    route: "/proveedores/pagos",
    perms: ["proveedores:read"],
    icon: <PaymentsOutlinedIcon />,
  },


  {
    type: "collapse",
    name: "Resultados",
    key: "costos-ganancias",
    route: "/costos-ganancias",
    perms: ["reportes:read"],
    icon: <PaidOutlinedIcon />,
  },

  { type: "title", title: "CONFIGURACIÓN", key: "title-configuracion" },
  {
    type: "collapse",
    name: "Sucursales",
    key: "sucursales",
    route: "/sucursales",
    perms: ["sucursales:manage"],
    icon: <StorefrontIcon />,
  },

  { type: "divider", key: "divider-1" },
  {
    type: "collapse",
    name: "Salir",
    key: "salir",
    route: "/logout",
    icon: <LogoutIcon />,
  },
];

export default routes;
